import { styled, Container, Typography, Paper, Button } from '@mui/material';
import { theme } from 'assets/themes/zizzi';
import { palette } from 'assets/styles/colors';
import LoginPhoto from 'assets/images/img-zizzi-homepage.png';
import Layout from 'layouts';

export const StyledLayout = styled(Layout)`
  padding-top: 0;
  display: flex;
  align-items: center;
  background: ${palette.blue[500]};

  ${theme.breakpoints.up('sm')} {
    background: url(${LoginPhoto}) center center no-repeat;
    background-size: cover;
    padding-top: 0;
  }
`;

export const Wrapper = styled(Container)`
  position: relative;
  z-index: 1;
  min-height: 780px;
  margin: 10px 0 30px;

  ${theme.breakpoints.up('sm')} {
    margin: auto;
    min-height: 495px;
    width: 690px;
    justify-content: center;
    display: flex;
    flex-direction: column;
    border-radius: 24px;
    background: ${palette.blue[500]};
    box-shadow: #32325d40 0px 13px 27px -5px, #0000004d 0px 8px 16px -8px;
  }
`;

export const Welcome = styled('div')`
  display: flex;
  justify-content: center;
  ${theme.breakpoints.up('sm')} {
    margin-top: 10px;
  }
`;

export const Content = styled('div')`
  align-items: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 1.5rem 1rem 0.5rem;
  width: 100%;

  ${theme.breakpoints.up('sm')} {
    padding: 0;
  }
`;

export const WelcomeText = styled(Typography)`
  color: ${theme.palette.orange};
  margin-bottom: 1rem;

  ${theme.breakpoints.up('sm')} {
    margin-bottom: 1.5rem;
  }
`;

export const Logo = styled('img')`
  max-width: 270px;
  position: relative;
  width: 100%;
  z-index: 1;

  ${theme.breakpoints.up('sm')} {
    max-width: 494px;
  }
`;

export const Graphic = styled('img')`
  max-width: 280px;
  position: relative;
  width: 100%;
  z-index: 1;

  ${theme.breakpoints.up('sm')} {
    display: none;
  }
`;

export const StyledPaper = styled(Paper)`
  border: none;
  box-shadow: none;
  background: ${palette.blue[500]};
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0 1rem;
`;

export const Text = styled(Typography)`
  font-size: 20px;
  line-height: 24px;
  text-align: center;
  color: ${palette.sunshine[50]};
  width: 250px;
  margin-bottom: 20px;

  ${theme.breakpoints.up('sm')} {
    margin-top: 10px;
    width: 490px;
    font-size: 28px;
    line-height: 34px;
    font-weight: 400;
    margin-bottom: 35px;
    font-size: 28px;
  }
`;

export const StyledButton = styled(Button)`
  background: ${palette.sunshine[50]};
  color: ${palette.blue[500]};
  font-weight: 700;
  font-size: 16px;
  width: 286px;
  margin-top: 24px;
  transition: ease-in-out;

  &:hover {
    background: ${palette.sunshine[50]};
  }

  &:pressed {
    background: ${palette.sunshine[50]};
  }

  ${theme.breakpoints.up('sm')} {
    margin-top: 0px;
    width: 550px;
  }
`;

export const AddToHomeScreenWrapper = styled('div')`
  color: white;
  display: flex;
  align-items: center;
  max-width: 390px;
  margin: 24px auto;
  padding: 0 0.5rem;
  gap: 10px;
  ${theme.breakpoints.up('sm')} {
    display: none;
  }
`;

export const IconWrapper = styled('div')`
  width: 87px;
`;

export const TextWrapper = styled('div')`
  width: 100%;
  max-width: 263px;
  color: ${palette.sunshine[50]};

  ${theme.breakpoints.up('xs')} {
    width: 263px;
  }
`;

export const StyledText = styled(Typography)`
  font-size: 16px;
  line-height: 21px;
  margin-bottom: 6px;

  ${theme.breakpoints.up('sm')} {
    display: none;
  }
`;

export const AndroidButton = styled('button')`
  border: none;
  padding: 0 0 2px 0;
  overflow: visible;
  background: transparent;
  margin: 0;
  line-height: 1.4;
  font-size: 16px;
  font-weight: 400;
  border-bottom: 1px solid ${palette.sunshine[50]};
  width: fit-content;
  color: ${palette.sunshine[50]};
  text-decoration: none;
  font: inherit;
  cursor: pointer;

  &:active {
    color: ${palette.sunshine[100]};
    border-bottom: 1px solid ${palette.sunshine[100]};
  }
`;
